import {type AnalyticsData, AnalyticsWrapper} from './analytics-wrapper';

export class GtmAnalyticsWrapper extends AnalyticsWrapper {
  /** The currently cached data before next GTM push. */
  private currentData: AnalyticsData = {};

  // TODO: to fix datalLayer is not defined issue.
  constructor(private readonly dataLayer: Array<unknown> | undefined) {
    super();
  }

  sendHit(
    type: string,
    data: AnalyticsData = {},
    timeout = 1000,
  ): Promise<void> {
    if (!type) {
      throw new Error('type must exist for sending hits.');
    }

    data['event'] = type;
    return this.push(data, timeout);
  }

  setField(fieldName: string, value: unknown): void {
    if (!fieldName) {
      throw new Error('fieldName must exist for sending hits.');
    }

    this.currentData[fieldName] = value;
  }

  push(data: AnalyticsData, timeout = 1000): Promise<void> {
    Object.assign(this.currentData, data);

    return new Promise<void>(resolve => {
      const dataToBePushed = this.currentData;
      this.currentData = {};

      let callbackTriggered = false;
      const callback = () => {
        if (!callbackTriggered) {
          callbackTriggered = true;
          resolve();
        }
      };

      dataToBePushed['eventCallback'] = callback;
      setTimeout(callback, timeout);

      this.dataLayer?.push(dataToBePushed);
    });
  }
}
